import React, { useEffect, useState, useRef } from "react";

import cssClasses from "./ViewProject.module.css";
import { useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

//*MUI
import { Box, Divider } from "@mui/material";

import WingsCard from "../../../Subcomponents/WingsCard/WingsCard";
import { BlockDiv } from "../../../Subcomponents/FloorComponent/FloorComponents";
import ThreeDotsMenu from "../../../Subcomponents/ThreeDotsMenu";
//Images
import Docs from "../../../Assets/Images/docs.svg";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import downloadIcon from "../../../Assets/Images/ProjectsCollateralIcons/downloadIcon.svg";
import PDFIcon from "../../../Assets/Images/ProjectsCollateralIcons/PDF.svg";
import shareIcon from "../../../Assets/Images/ProjectsCollateralIcons/shareIcon.svg";
import DOCIcon from "../../../Assets/Images/ProjectsCollateralIcons/DOC.svg";
import XLSIcon from "../../../Assets/Images/ProjectsCollateralIcons/XLS.svg";
import Mp4Icon from "../../../Assets/Images/ProjectsCollateralIcons/MP4.svg";
import PPTIcon from "../../../Assets/Images/ProjectsCollateralIcons/PPT.svg";
import FileIcon from "../../../Assets/Images/ProjectsCollateralIcons/file.svg";
import noCollaterals from "../../../Assets/Images/NoCollaterals.svg";
import {
  getAllUnitsByProjectId,
  getAllUnitsByWingId,
  getAllWingsByProjectId,
  getProjectCollaterals,
  getProjectPricing,
} from "../../../Services/Inventory";
import backArrow from "../../../Assets/Images/backArrow.svg";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../Redux Store/actions";

//share
import { EmailShareButton, WhatsappShareButton } from "react-share";
import { EmailIcon, WhatsappIcon } from "react-share";
import ClickAwayListener from "@mui/material/ClickAwayListener";

//download
import JsFileDownloader from "js-file-downloader";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import { groupBy, sortBy } from "lodash";
export default function ViewProject() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);
  const [AllWings, setAllWings] = useState([]);
  const [TotalUnits, setTotalUnits] = useState(0);
  const [TotalWings, setTotalWings] = useState(0);
  const [UnitStatus, setUnitStatus] = useState([]);
  const [noWingsPresent, setNoWingsPresent] = useState(null);
  const [showInventory, setShowInventory] = useState(false);
  const [Units, setUnits] = useState([]);
  const [selectedWing, setSelectedWing] = useState(null);
  const [allCollaterals, setAllCollaterals] = useState([]);
  // const [getProject,setProject]=useState(null);
  const [tabs, setTab] = useState(["Collateral"]);
  // const [tabs, setTab] = useState(["Collateral", "Inventory"]);
  let project = JSON.parse(localStorage.getItem("project"));
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);

  useEffect(() => {
    dispatch(actions.activeMenu("projects"));
    console.log(project);
    getAllCollaterals();
    getAllWings();
  }, []);
  function getAllCollaterals() {
    console.log(loggedInUser);
    getProjectCollaterals(loggedInUser?.cpId, project.projectId).then(
      (resp) => {
        console.log("projectColateral", resp);
        resp.data = resp.data.map((each, index) => ({
          ...each,
          showShare: false,
        }));
        setAllCollaterals([...resp.data]);
      }
    );
  }
  function getAllWings() {
    getAllWingsByProjectId(project.projectId).then((res) => {
      console.log("ALL-WINGS", res);
      if (res.count > 0) {
        setNoWingsPresent(true);
      } else {
        setNoWingsPresent(false);
      }
      res.data=res.data.map((el)=>({
        ...el,wingName:el.wingname,wingId:el.wingid
      }))
      setAllWings(res.data);
      setTotalWings(res.count);
    });

    // getAllUnitsByProjectId(project.projectId).then((response) => {
    //   console.log("Total-Units", response.data);
    //   setUnitStatus(response.data);
    //   setTotalUnits(response.count);
    // });
  }
  const tabChange = (event, newValue) => {
    setTabValue(newValue);
    setAllCollaterals((pre) => {
      pre = pre.map((m) => ({
        ...m,
        showShare: false,
      }));
      return [...pre];
    });
  };
  function numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000).toFixed(2) + " Cr";
    else if (val >= 100000) val = (val / 100000).toFixed(2) + " Lac";
    else if (val >= 1000) val = (val / 1000).toFixed(2) + " K";
    return val;
  }
  function goToWing(wingId, wingName) {
    setSelectedWing(wingName);
    setShowInventory(true);
    getAllUnitsByWingId(project.projectId, wingId).then((response) => {
      response.data=response.data.filter(({unitId})=>unitId!==null);
      response.data=response.data.map((el)=>({
        ...el,floorNo:el.unitId.floorNo,
        unitNo:el.unitId?.unitNo,
        inventoryType:el?.unitId?.inventoryTypeId?.type
      }))
      // response.data=response.data.filter(({unitId})=>unitId!==null);

      // if(response.count > 0) {
      //   setNoFloorsPresent(true)
      // } else {
      //   setNoFloorsPresent(false)
      // }
    
      console.log(groupBy(response.data, "floorNo"));
      setUnits(groupBy(response.data, "floorNo"));
             setTotalUnits(response.data.length);
      let count = 0;
      // ??project pricing don't show for now if client asks we can sow it to them
      // presentLoader();
      // response.data.forEach((el) => {
      //   getProjectPricing(
      //     project.projectId,
      //     wingId,
      //     el.inventoryTypeId.inventoryTypeId
      //   )
      //     .then((projectResp) => {
      //       console.log("projectPrice", projectResp.data[0].Total);
      //       count = count + 1;
      //       el.projectPrice = numDifferentiation(projectResp.data[0].Total);
      //       if (count === response.count) {
      //         dismissLoader();
      //         setUnits(groupBy(response.data, "floorNo"));
      //         setTotalUnits(response.count);
      //         console.log("AllUnits", response.data);
      //       }
      //     })
      //     .catch((err) => {
      //       dismissLoader();
      //       console.log(err);
      //     });
      // });
     
    });
  }
  function FloorSuffix(floorNo) {
    var j = floorNo % 10,
      k = floorNo % 100;
    if (j === 1 && k !== 11) {
      return floorNo + "st";
    }
    if (j === 2 && k !== 12) {
      return floorNo + "nd";
    }
    if (j === 3 && k !== 13) {
      return floorNo + "rd";
    }
    return floorNo + "th";
  }
  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        sx={[
          {
            fontFamily: "Inter-Medium !important",
            fontStyle: "normal !important",
            fontWeight: "500 !important",
            fontSize: "1.6rem!important",
            lineHeight: "2.4rem!important",
            textTransform: "none !important",
          },
        ]}
      />
    );
  });
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperHeader}>
        <div className={cssClasses.headerTitle}>
          <img
            src={backArrow}
            alt=""
            onClick={() => {
              navigate("/Home/Projects");
            }}
            style={{ cursor: "pointer", marginRight: "1rem" }}
          />
          <span>{project.projectName}</span>
        </div>
        <div className={cssClasses.headerSubTitle}>{project.addressline1}{project.addressline2}{project.addressline3}</div>
        {/* <div className={cssClasses.globalBackArrow}>
              <img
                src={backArrow}
                alt=""
                onClick={() => {
                  navigate('/Home/Projects');
                }}
                style={{ cursor: "pointer" }}
              />
              <span
                onClick={() => {
                  navigate('/Home/Projects');
                }}
                style={{ cursor: "pointer" }}
              >
                Back
              </span>
            </div> */}
      </div>
      <div className={cssClasses.wrapperTabs}>
        <Tabs
          value={tabValue}
          onChange={tabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Fos Lists"
          sx={[
            {
              borderBottom: "1px solid #EAECF0 !important",
            },
          ]}
        >
          {tabList}
        </Tabs>
      </div>
      <div className={cssClasses.wrapperContent}>
        {tabValue === 0 && allCollaterals.length >= 0 && (
          <div className={cssClasses.wrapperCollaterals}>
            {/* {docType==='Image'} */}
            {allCollaterals?.map((each, index) => (
              <div className={cssClasses.wrapperDocument}>
                {/* <div className={cssClasses.wrapperThreeDotsMenu}>
                  <ThreeDotsMenu
                    list={["Download", "Share"]}
                    selectedValue={(e) => {
                      console.log(e);
                      if (e === "Share") {
                        setAllCollaterals((pre) => {
                          pre[index].showShare = true;
                          return [...pre];
                        });
                      } else {
                        presentLoader();
                        new JsFileDownloader({
                          url:
                            process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                            "projectcollaterals/" +
                            each.ProjectCollaterals?.collateralUrl,
                        })
                          .then(function () {
                            dismissLoader();
                            // Called when download ended
                          })
                          .catch(function (error) {
                            console.log(error);
                            // Called when an error occurred
                          });
                      }
                    }}
                  />
                </div> */}
                 {each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "pdf" ? (
                            <div className={cssClasses.wrapperIconBlock}>
                              <img src={PDFIcon} alt="Pdf" />
                            </div>
                          ) : (
                            each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "webp" ? (
                              // eslint-disable-next-line jsx-a11y/img-redundant-alt
                              <div className={cssClasses.wrapperIconBlock1}>
                                <img
                                  style={{
                                    height: "15rem",
                                    objectFit: "fill",
                                  }}
                                  src={
                                    process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                                    each?.ProjectCollaterals?.collateralUrl
                                  }
                                  alt="Img"
                                />
                              </div>
                            ) : (
                              each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "docx" || each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "doc") ? (
                              <div className={cssClasses.wrapperIconBlock}>
                                <img src={DOCIcon} alt="DOC" />
                              </div>
                            ) : (
                              each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "xls" || each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "xlsx") ? (
                              <div className={cssClasses.wrapperIconBlock}>
                                <img src={XLSIcon} alt="XLSX" />
                              </div>
                            ) : (
                              each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "mp4" || each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "mov" || each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "mkv" || each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "avi" || each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "webm") ? (
                              <div className={cssClasses.wrapperIconBlock}>
                                <img src={Mp4Icon} alt="Video" />
                              </div>
                            ) : (
                              each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "ppt" || each?.ProjectCollaterals?.collateralUrl?.split(".").pop() === "pptx") ? (
                              <div className={cssClasses.wrapperIconBlock}>
                                <img src={PPTIcon} alt="PPT" />
                              </div>
                            ) : (
                              <div className={cssClasses.wrapperIconBlock}>
                                <img src={FileIcon} alt="File" />
                              </div>
                            )
                          )}
                <div className={cssClasses.wrapperTitle}>
                  <div className={cssClasses.Title}>
                    {each?.ProjectCollaterals?.collateralUrl?.substring(
                      each?.ProjectCollaterals?.collateralUrl?.lastIndexOf(
                        "/"
                      ) + 1
                    )}
                  </div>
                  <div className={cssClasses.wrapperShareDownload}>
                    <img
                      style={{ cursor: "pointer" }}
                      src={downloadIcon}
                      alt="downloadIcon"
                      onClick={() => {
                        new JsFileDownloader({
                          url:
                            process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                            "projectcollaterals/" +
                            each.ProjectCollaterals?.collateralUrl,
                        })
                          .then(function () {
                            dismissLoader();
                            // Called when download ended
                          })
                          .catch(function (error) {
                            console.log(error);
                            // Called when an error occurred
                          });
                      }}
                    ></img>

                    <img
                      src={shareIcon}
                      alt="shareIcon"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setAllCollaterals((pre) => {
                          pre[index].showShare = true;
                          return [...pre];
                        });
                      }}
                    />
                    {each.showShare && each === allCollaterals[index] && (
                      <ClickAwayListener
                        onClickAway={() => {
                          setAllCollaterals((pre) => {
                            pre[index].showShare = false;
                            return [...pre];
                          });
                        }}
                      >
                        <div className={cssClasses.wrapperShare}>
                          <WhatsappShareButton
                            url={
                              process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                             
                              each.ProjectCollaterals?.collateralUrl
                            }
                            title={project.projectName}
                          >
                            <WhatsappIcon size={32} round={true} />
                          </WhatsappShareButton>
                          <EmailShareButton subject={project.projectName}>
                            <EmailIcon size={32} round={true}></EmailIcon>
                          </EmailShareButton>
                        </div>
                      </ClickAwayListener>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        {tabValue === 0 && allCollaterals.length === 0 && (
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={noCollaterals} alt="No Collaterals" />
            </div>
            <div className={cssClasses.emptyTitle}>No Collaterals Found</div>
          </div>
        )}

        {tabValue === 1 && showInventory === false && (
          <div className={cssClasses.wrapperCollateral}>
            <div margin={"2rem 0"} className={cssClasses.wrapperTotalCount}>
              <Box className={cssClasses.Title}>
                Total Wings :
                <Box
                  component={"span"}
                  className={cssClasses.NumberTitle}
                  ml={2}
                >
                  {TotalWings}
                </Box>
              </Box>
              {/* <Box className={cssClasses.Title}>
                Total Units :
                <Box
                  component={"span"}
                  className={cssClasses.NumberTitle}
                  ml={2}
                >
                  {TotalUnits}
                </Box>
              </Box> */}
            </div>
            <div className={cssClasses.wrapperCard}>
              {sortBy(AllWings,'wingName')?.map((wing, index) => (
                <Box component={"span"} key={`${wing}_${index}`}>
                  <WingsCard
                    clicked={() => {
                      goToWing(wing.wingId, wing.wingName);
                    }}
                    wingName={wing.wingName}
                  />
                </Box>
              ))}
            </div>
          </div>
        )}
        {tabValue === 1 && AllWings.length === 0 && showInventory === false && (
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={noCollaterals} alt="No Wings" />
            </div>
            <div className={cssClasses.emptyTitle}>No Wings Found</div>
          </div>
        )}
        {showInventory && tabValue === 1 && (
          <>
            <div className={cssClasses.wrapperBackArrow}>
              <img
                src={backArrow}
                alt=""
                onClick={() => {
                  getAllWings();
                  setShowInventory(false);
                }}
                style={{ cursor: "pointer" }}
              />
              <span
                onClick={() => {
                  getAllWings();
                  setShowInventory(false);
                }}
                style={{ cursor: "pointer" }}
              >
                Back
              </span>
            </div>
            <Box margin={"2rem 0"} className={cssClasses.wrapperTotalCount}>
              <Box className={cssClasses.Title}>
                Selected Wing :
                <Box
                  component={"span"}
                  className={cssClasses.NumberTitle}
                  // ml={2}
                >
                {selectedWing}
                  {/* {selectedWing?.includes('WING')?{selectedWing}:<span>Wing {selectedWing}</span> } */}
                </Box>{" "}
              </Box>

              <Box className={cssClasses.Title}>
                Total Available Units :
                <Box
                  component={"span"}
                  className={cssClasses.NumberTitle}
                  // ml={2}
                >
                  {TotalUnits}
                </Box>{" "}
              </Box>
            </Box>

            <Box className={cssClasses.Floor}>
              <Box className={cssClasses.FloorTitle}>Floor</Box>
            </Box>
            {Object.keys(Units).map((unitKey, unitKeyIndex) => (
              <Box mb={4} key={`${unitKey}_${unitKeyIndex}`}>
                <Box className={cssClasses.firstTitle}>
                  {FloorSuffix(unitKey)}
                </Box>
                <Box className={cssClasses.MainDiv}>
                  <Divider />
                  <Box className={cssClasses.flexRow}>
                    {sortBy(Units[unitKey], "unitNo")?.map((unit, index) => (
                      <BlockDiv
                      style={{ color: "#027A48", backgroundColor: "#D1FADF" }}
                     
                      Size={unit?.inventoryType}
                      paired={unit.mergeId? true : false}
                       pairedInfo={(unit?.unitId?.unitId === unit?.mergeId?.unit1Id) ? `Paired with ${unit?.mergeId?.unit2No}` : `Paired with ${unit?.mergeId?.unit1No}`  }
                      flatNo={unit?.unitId?.unitNo}
                      // Price={unit?.projectPrice}
                    />
                    ))}
                  </Box>
                </Box>

                <Divider />
              </Box>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
